import { render, staticRenderFns } from "./MarketingRecord.vue?vue&type=template&id=313e75d6&scoped=true"
import script from "./MarketingRecord.vue?vue&type=script&lang=js"
export * from "./MarketingRecord.vue?vue&type=script&lang=js"
import style0 from "./MarketingRecord.vue?vue&type=style&index=0&id=313e75d6&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313e75d6",
  null
  
)

export default component.exports